var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_vm._l((_vm.notifications),function(snackbar,index){return _c('v-snackbar',{key:index,attrs:{"color":snackbar.type,"timeout":1900,"top":true,"right":true},model:{value:(snackbar.show),callback:function ($$v) {_vm.$set(snackbar, "show", $$v)},expression:"snackbar.show"}},[_vm._v(" "+_vm._s(snackbar.message)+" ")])}),_c('router-view')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }